/*
 * @Author: 张印 hbzyin@163.com
 * @Date: 2023-08-09 15:32:13
 * @LastEditors: liupan
 * @LastEditTime: 2023-12-27 09:51:56
 * @FilePath: /code/mall-fe/src/views/NewIndex/components/HeaderSearchInput.tsx
 * @Description: 商城新版门户首页头部搜索组件
 *
 */
import jsurl from 'jsurl';
// import useAreaCookie from 'hooks/useAreaCookie';
import { SiteContext } from 'libs/contexts';
import { SearchTypeEnum } from 'libs/enums';
import { useContext, useState } from 'react';
// import { getFirstTownOfCityCode } from 'api/user';
import { useRouter } from 'next/router';
import { cls } from 'reactutils';
import { Select } from 'antd';

const HeaderSearchInput = ({ hideSearchType }: { hideSearchType: boolean }) => {
  const site = useContext(SiteContext);
  const route = useRouter();
  // 根据路由返回初始tab值
  const curTab = () => {
    if (route.pathname === '/pages/jjzq') {
      // return SearchTypeEnum.BUSINESS.value;
      return SearchTypeEnum.GOODS.value;
    } else if (route.pathname === '/pages/dfzq' || route.pathname === '/pages/dfzq/[id]') {
      // return SearchTypeEnum.HOUSE.value;
      return SearchTypeEnum.GOODS.value;
    } else if (route.pathname === '/shop/list') {
      return SearchTypeEnum.STORE.value;
    } else {
      return SearchTypeEnum.GOODS.value;
    }
  };
  // 搜索框上方tab值
  const [curSearchTab, setCurSearchTab] = useState(curTab);
  const query = route.query ?? {};

  const isShopProPage =
    route.pathname?.startsWith('/pages/shop/pro') && route.pathname !== '/pages/shop/pro/404';
  const [keyWord, setKeyWord] = useState(getInitKeyWord());

  // 获取初始搜索框内容
  function getInitKeyWord() {
    try {
      if (route.pathname === '/pages/jjzq' || route.pathname === '/pages/dfzq') {
        return route.query?.keyword as string;
      } else if (isShopProPage) {
        const params = jsurl.parse(route.query.params) ?? {};
        const { keywords } = params;
        return keywords ? decodeURIComponent(keywords) : '';
      } else if (route.pathname === '/product/list') {
        return route.query?.key as string;
      } else if (route.pathname === '/shop/list') {
        return route.query?.key as string;
      } else {
        return '';
      }
    } catch (error) {
      return '';
    }
  }

  // 搜索框搜索
  function handleToSearch() {
    let url: string;
    if (curSearchTab === SearchTypeEnum.GOODS.value) {
      if (!keyWord) setKeyWord('钢筋');
      url = '/product/list?key=';
      if (route.pathname === '/product/list') {
        route.push(
          {
            pathname: '/product/list',
            query: {
              ...route.query,
              key: keyWord?.trim() || '钢筋',
            },
          },
          null,
          {
            shallow: true,
          },
        );
        return;
      }
    } else if (curSearchTab === SearchTypeEnum.STORE.value) {
      url = '/shop/list?key=';
    } else if (curSearchTab === SearchTypeEnum.HOUSE.value) {
      url = '/pages/dfzq?keyword=';
    } else {
      url = '/pages/jjzq?keyword=';
    }
    // return;
    location.href = `${url}${
      keyWord
        ? encodeURIComponent(keyWord.trim())
        : curSearchTab === SearchTypeEnum.GOODS.value
        ? '钢筋'
        : ''
    }`;
  }

  // 搜索框添加placeholder
  // function appendPlaceholder(cur: number) {
  //   if (cur === SearchTypeEnum.GOODS.value && site?.mall?.enableSelfSiteMode === SITE_MODE.SELF) {
  //     return '、配送商名称';
  //   }
  //   return '';
  // }
  // 店铺内搜索
  function handleToSearchShop() {
    if (!keyWord) setKeyWord('钢筋');
    const param = {
      keywords: keyWord ? encodeURIComponent(keyWord.trim()) : '钢筋',
      ts: new Date().valueOf(),
      // 搜索列表,默认进入选中全区域产品
      showAllAddressId: false,
    };

    const newQuery = {
      ...query,
      params: jsurl.stringify(param),
    };
    const url = {
      pathname: `/pages/shop/pro/list/${query.shopSysNo}`,
      query: newQuery,
    };

    const queryStr = Object.entries(newQuery)
      .map((item) => item.join('='))
      .join('&');

    const urlStr = `${url.pathname}?${queryStr}`;
    route.push(url, urlStr, {
      shallow: true,
    });
  }

  // const { areaSysNo, setCookie, AREA_CODE_KEY, AREA_SYS_NO_KEY, setAreaObjByCookie } =
  //   useAreaCookie();

  // // 地区修改时调用
  // async function handleAreaChange(data: string[], reloadAreaInfo) {
  //   if (!data || !data?.length) return;
  //   // 根据市 查询最后一级地区信息
  //   let res = await getFirstTownOfCityCode(data[data.length - 1]);
  //   if (res?.code === 200 && res?.data) {
  //     setCookie(AREA_CODE_KEY, res.data.levelCode);
  //     setCookie(AREA_SYS_NO_KEY, res.data.sysNo);

  //     if (reloadAreaInfo) {
  //       setAreaObjByCookie();
  //     }

  //     // 刷新页面
  //     window.location.reload();
  //   }
  // }
  return (
    <div className={cls('search', isShopProPage && 'search-shop-pro')}>
      <Select
        value={curSearchTab}
        onChange={setCurSearchTab}
        options={Object.values(SearchTypeEnum)}
      />
      <span className="sep" />
      <input
        className="search-input"
        type="text"
        value={keyWord}
        onChange={(val) => setKeyWord(val.target.value)}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            isShopProPage ? handleToSearchShop() : handleToSearch();
          }
        }}
        placeholder={'请输入关键词'}
      />
      {isShopProPage ? (
        <span className="search-btn">
          <button className="search-btn-all" onClick={handleToSearch}>
            搜全站
          </button>
          <button className="search-btn-shop-new" onClick={handleToSearchShop}>
            搜本店
          </button>
        </span>
      ) : (
        <i
          className="iconfont icon-sousuo2"
          onClick={handleToSearch}
          style={{
            color: '#999999',
            fontSize: '14px',
            float: 'right',
            lineHeight: '34px',
            cursor: 'pointer',
          }}
        />
      )}

      <style jsx>{`
        .search {
          width: 348px;
          height: 36px;
          padding-right: 16px;
          justify-content: ${isShopProPage ? 'flex-start' : 'space-between'};
          align-items: center;
          border-radius: 4px;
          border: 1px solid #D5D6DE;
          overflow: hidden;
          position: relative;
          display: flex;
        }
        .search :global(.ant-select-selection-item) {
          display: flex;
          align-items: center;
        }
        .search-tab {
          width: auto;
          height: 44px;
          background-color: #fff;
          padding-left: 12px;
          z-index: 2;
          cursor: pointer;
        }
        .search-type-name {
          display: inline-block;
          line-height: 44px;
          font-size: 14px;
          color: #333;
        }
        .search :global(.ant-select-selector) {
          border: none;
          padding: 0 16px;
          box-shadow: none !important;
          border-color: transparent !important:
          border-right-width: 0 !important;
        }
        .sep {
          display: inline-block;
          margin-right: 16px;
          border-right: 1px solid #D9D9D9;
          height: 16px;
          vertical-align: middle;
        }
        .trigger-icon {
          display: block;
          width: 0;
          height: 0;
          border-top: 4px solid #666;
          border-left: 3px solid transparent;
          border-right: 3px solid transparent;
          margin-left: 7px;
        }
        .search-type {
          display: ${hideSearchType ? 'none' : 'flex'};
          position: absolute;
          top: -28px;
          left: -2px;
          height: 26px;
          background-color: #fff;
        }
        .search-type-item {
          width: 72px;
          line-height: 26px;
          font-size: 16px;
          color: #333;
          margin-right: 4px;
          border-radius: 4px 4px 0 0;
          text-align: center;
          cursor: pointer;
        }
        .search-type-item:hover,
        .search-type-item.active {
          color: #fff;
          background-color: ${site?.global?.platformMainColor};
        }

        .search-input {
          // flex: 1;
          width: ${isShopProPage ? '84px' : '180px'};
          line-height: 34px;
          border: 0;
          font-size: 14px;
          color: #333;
        }
        .search-btn {
          position: absolute;
          top: 0;
          right: 0;
          border-radius: 4px;
          overflow: hidden;
        }

        .search-btn-all {
          height: 36px;
          color: #018DD7;
          font-size: 14px;
          border: 1px solid transparent;
          cursor: pointer;
          background-color: rgba(1, 141, 215, 0.1);
          padding: 0 12px;
        }

        .search-btn-shop-new {
          height: 36px;
          color: #fff;
          font-size: 14px;
          border: 1px solid ${site?.global?.platformMainColor};
          cursor: pointer;
          background: ${site?.global?.platformMainColor};
          padding: 0 12px;
        }
      `}</style>
    </div>
  );
};
export default HeaderSearchInput;
